import PropTypes from 'prop-types'
import { convertSvgToBase64Uri } from 'app/utils'
import clsx from 'clsx'
import Styles from './styles.module.scss'

// This component only used for rendering svg icons as mask image
function IconAsMaskImage({ svg = null, size = '', className = '', color = '#000000', ...rest }) {
  const customCssVariables = {
    '--raychat-icon-bg-image': convertSvgToBase64Uri(svg),
    '--raychat-icon-bg-image-size': size,
    '--raychat-icon-bg-color': color,
  }

  return <span className={clsx(Styles.icon, 'icon_wrapper', className)} style={customCssVariables} {...rest} />
}

IconAsMaskImage.propTypes = {
  svg: PropTypes.element,
  className: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
}

export default IconAsMaskImage
